module.exports = __webpack_public_path__ + "static/media/sell_request_details_make_3-3.cfec3172.png";